export default __webpack_public_path__ + "static/media/NotoSansKR-Light.45736342.woff";